module.exports = __webpack_public_path__ + "static/SoleilBold-7fbdec475154bd430a54d1ba426ab4db.otf";